module.exports = __webpack_public_path__ + "img/img32.f7108ed8.svg";